export const DL_ERROR_PAGE_LOADED = 'hg/error/DL_PAGE_LOADED';
export const HANDLE_ERROR = 'hg/error/HANDLE_ERROR';
export const HANDLE_INTERACTION = 'mp/error/HANDLE_INTERACTION';
export * from './errorHelpers';

// this is just for logging errors on the server
export const errorTypes = {
  EXCEPTION : 'Exception',
  REDIRECT : 'Redirect'
};
export const loadContent = (routePath) => {
  return {
    type: DL_ERROR_PAGE_LOADED,
    path: routePath
  };
};
export const handleInteraction = () => {
  return {
    type: HANDLE_INTERACTION
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/error/error.js
 **/